import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { IterationRule } from 'schemas/IterationRule.schema.ts';

export function getIterationRulesById(campaign: CampaignConfig, iterationId: string): IterationRule[] | undefined {
  if (!campaign.CampaignConfig?.Iterations) return undefined;

  const foundIteration = campaign.CampaignConfig?.Iterations.find((iteration) => iteration.ID === iterationId);

  if (!foundIteration) return undefined;

  return foundIteration.IterationRules;
}

export function getRuleInIterationRules(iterationRules: IterationRule[], andNumber: number, rulePriority: number | undefined, ruleType: string | undefined): IterationRule | undefined {
  if (rulePriority === undefined || ruleType === undefined) {
    return undefined;
  }

  return iterationRules.find((rule) => (
    rule?.AndNumber === andNumber
    && rule?.Priority === rulePriority
    && rule?.Type === ruleType
  ));
}

export function getAvailableRoutingIds(state: CampaignConfig, routingIds: string[]): CampaignConfig {
  return {
    ...state,
    CampaignConfig: {
      ...state.CampaignConfig,
      AvailableRoutingIds: routingIds,
    },
  };
}

export function getIterationRoutingIds(
  state: CampaignConfig,
  updates: { name: string; old: string; new: string }[],
): CampaignConfig {
  return {
    ...state,
    CampaignConfig: {
      ...state.CampaignConfig,
      Iterations:
        state.CampaignConfig.Iterations?.map((iteration) => {
          const matchingUpdate = updates.find(
            (update) => update.name === iteration.Name,
          );
          if (matchingUpdate) {
            return {
              ...iteration,
              DefaultCommsRouting: matchingUpdate.new,
            };
          }
          return iteration;
        }) || [],
    },
  };
}

export function getIterationRulesRoutingIds(
  state: CampaignConfig,
  updates: { name: string; old: string; new: string }[],
): CampaignConfig {
  return {
    ...state,
    CampaignConfig: {
      ...state.CampaignConfig,
      Iterations:
        state.CampaignConfig.Iterations?.map((iteration) => {
          if (iteration.IterationRules) {
            return {
              ...iteration,
              IterationRules:
                iteration.IterationRules.map((rule) => {
                  const matchingUpdate = updates.find(
                    (update) => update.name === rule.Name,
                  );
                  if (
                    matchingUpdate
                    && rule.CommsRouting === matchingUpdate.old
                  ) {
                    return {
                      ...rule,
                      CommsRouting: matchingUpdate.new,
                    };
                  }
                  return rule;
                }),
            };
          }
          return iteration;
        }) || [],
    },
  };
}

export function getCampaignAvailableRoutingIds(campaign: CampaignConfig) {
  if (campaign.CampaignConfig?.AvailableRoutingIds) {
    return campaign.CampaignConfig.AvailableRoutingIds;
  }

  const routingIds = new Set<string>();

  if (campaign.CampaignConfig?.DefaultCommsRouting && campaign.CampaignConfig.DefaultCommsRouting !== 'PLACEHOLDER_COMMS_ROUTING') {
    campaign.CampaignConfig.DefaultCommsRouting.split('|').forEach((routing) => {
      routingIds.add(routing.trim());
    });
  }

  campaign.CampaignConfig?.Iterations?.forEach((iteration) => {
    if (iteration.DefaultCommsRouting) {
      iteration.DefaultCommsRouting.split('|').forEach((routing) => {
        routingIds.add(routing.trim());
      });
    }

    iteration.IterationRules?.forEach((rule) => {
      if (rule?.CommsRouting) {
        rule.CommsRouting.split('|').forEach((routing) => {
          routingIds.add(routing.trim());
        });
      }
    });
  });

  return Array.from(routingIds);
}
